import { useState } from "react";
import axios from "axios";
import { Heart } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "pame3d_likes";
const liked = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export const CreationCard = ({ c, onLike }) => {
  const { t, lang } = useLang();
  const s = t.gallery;
  const [likes, setLikes] = useState(c.likes || 0);
  const [mine, setMine] = useState(liked().includes(c.id));
  const [pop, setPop] = useState(false);

  const like = async () => {
    if (mine) return;
    setMine(true); setLikes(likes + 1); setPop(true);
    localStorage.setItem(KEY, JSON.stringify([...liked(), c.id]));
    try { const r = await axios.post(`${API}/creations/${c.id}/like`); setLikes(r.data.likes); onLike && onLike(c.id, r.data.likes); } catch {}
    setTimeout(() => setPop(false), 400);
  };

  return (
    <figure data-testid={`gallery-item-${c.id}`} className="bg-white rounded-2xl overflow-hidden border border-black/5 h-full flex flex-col">
      <img src={`${process.env.REACT_APP_BACKEND_URL}${c.image}`} alt={`${c.caption} — ${c.name}`} loading="lazy" className="w-full aspect-[9/10] object-cover" />
      <figcaption className="p-4 flex-1 flex flex-col gap-1">
        <div className="flex items-start justify-between gap-2">
          <p className="font-serif-d text-lg font-semibold text-[#132A1D] leading-tight">{c.name}</p>
          <button data-testid={`like-btn-${c.id}`} onClick={like} aria-pressed={mine} title={s.like}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold transition-colors duration-200 ${mine ? "bg-[#C86A4B]/10 text-[#C86A4B]" : "bg-[#EFECE6] text-[#5C5C5C] hover:text-[#C86A4B]"}`}>
            <Heart size={14} className={`${mine ? "fill-[#C86A4B]" : ""} ${pop ? "scale-125" : ""} transition-transform duration-300`} />
            <span data-testid={`like-count-${c.id}`}>{likes}</span>
          </button>
        </div>
        <p className="text-xs text-[#5C5C5C] line-clamp-2">{c.caption}</p>
        <div className="mt-auto pt-2 flex items-center justify-between text-[11px]">
          <span className="uppercase tracking-wider text-[#C86A4B] font-bold">{s.games[c.game]}</span>
          <span className="text-[#5C5C5C]">{new Date(c.created_at).toLocaleDateString(lang === "es" ? "es-CO" : "en-US", { day: "numeric", month: "short" })}</span>
        </div>
      </figcaption>
    </figure>
  );
};
